import CadastralSituationDetails from "./CadastralSituationDetails";
import CadastralSituationResearch from "./CadastralSituationResearch";

export default {
  CadastralSituationDetails,
  CadastralSituationResearch
}

